import axios from 'axios'
import { get, post, del,getfile } from '@/http/request'
import { HOST } from '@/http/config'

// 列表
export function getSwitchingRoomlist(params) {
  return get(`${HOST}basis-switching-room/list`, params)
}
// 根据id删除
export function delSwitchingRoom(params) {
  return del(`${HOST}basis-switching-room/delete`, params)
}
// 详情
export function getSwitchingRoomDetails(params) {
  return get(`${HOST}basis-switching-room/get`, params)
}
// 新增
export function saveSwitchingRoom(params) {
  return post(`${HOST}basis-switching-room/save`, params)
}
// 修改
export function updateSwitchingRoom(params) {
  return post(`${HOST}basis-switching-room/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-switching-room-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-switching-room-history/get`, params)
}
// 导出
export function Export(params) {
  return getfile(`${HOST}basis-switching-room/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/powerDistributeRoom/api.js